import React from 'react';
import { PRODUCT_NAME, SUPPORT_EMAIL } from '../data/atlante';
export function Footer() {
  return <footer className="bg-deep px-4 py-4 text-center" data-id="element-67" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-3xl space-y-1.5" data-id="element-68" data-mp="3ghc0pwojutll">
        <p className="text-[11px] font-medium leading-snug text-white/60" data-id="element-69" data-mp="32ovukn0cqfgg">
          © 2026 {PRODUCT_NAME} — Tutti i diritti riservati. {PRODUCT_NAME}{' '}
          fornisce risorse educative e professionali destinate ai professionisti
          del settore odontoiatrico e protesico. Non sostituisce la formazione
          professionale richiesta, l’abilitazione, una diagnosi, le linee guida
          applicabili né il giudizio clinico del professionista.
        </p>
        <nav aria-label="Note legali" className="flex flex-wrap justify-center gap-2 text-[11px] font-bold uppercase tracking-wide text-white/75" data-id="element-70" data-mp="3qd6tvlqeg72m">
          <a href="#" className="transition-colors duration-150 hover:text-gold" data-id="element-71" data-mp="2a1jkhcbdo041">
            Termini e condizioni
          </a>
          <span aria-hidden="true" data-id="element-72" data-mp="3l90n1twdyuy7">•</span>
          <a href="#" className="transition-colors duration-150 hover:text-gold" data-id="element-73" data-mp="3l9sj15twaup0">
            Informativa sulla privacy
          </a>
          <span aria-hidden="true" data-id="element-74" data-mp="3v7q79tbr8rhm">•</span>
          <a href="#" className="transition-colors duration-150 hover:text-gold" data-id="element-75" data-mp="3v8rko4g8tq2i">
            Contatti
          </a>
        </nav>
        <p className="text-[11px] font-bold text-white/75" data-id="element-76" data-mp="3qapzndz9bgoe">
          Supporto:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-gold transition-colors duration-150 hover:text-white" data-id="element-77" data-mp="81fpbv4sgq3o">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </footer>;
}